import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ComponentsModule } from '../components/components.module';
import { ChildComponentsModule } from '../components/child-components.module';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CountdownModule } from 'ngx-countdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import { MatExpansionModule } from '@angular/material/expansion';
import { TooltipModule } from 'ng2-tooltip-directive';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { addOnCouponDialog, NewProductComponent } from './new-product.component';
import { FooterViewDialog1, ProductCouponDialog1, FormDialog, DownloadForm } from './new-product.component';

export const routes: any[] = [
  {
    path: '', component: NewProductComponent
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ChildComponentsModule,
ComponentsModule,
    MatButtonModule,
    MatSnackBarModule,
    MatTabsModule,
    MatCheckboxModule,
    MatIconModule,
    SlickCarouselModule,
    FormsModule,
    ReactiveFormsModule,
    CountdownModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatBottomSheetModule,
    MatExpansionModule,
    TooltipModule,
    ShareButtonsModule,
    ShareIconsModule,
  ],
  declarations: [
    NewProductComponent,
    FooterViewDialog1, ProductCouponDialog1, FormDialog, DownloadForm, addOnCouponDialog
  ],

  entryComponents: [
  ]

})
export class NewProductModule { }